import { getPintMasters, Pint } from '@api/pint';
import { useRequest } from './utils';

/**
 * Gets a list of masters from PINT. The complete list of available masters is
 * in `Pint.MasterSet` interface. Optionally, you can provide a key to pick the
 * master you need.
 * @param pick The master set to pick.
 */
export function usePintMaster<T extends keyof Pint.MasterSet>(
  pick: T
): UseMasterReturn<Pint.MasterSet[T]>;
/**
 * Gets a list of masters from PINT. The complete list of available masters is
 * in `Pint.MasterSet` interface. Optionally, you can provide a key to pick the
 * master you need.
 */
export function usePintMaster(): UseMasterReturn<Pint.MasterSet>;
/**
 * Gets a list of masters from PINT. The complete list of available masters is
 * in `Pint.MasterSet` interface. Optionally, you can provide a key to pick the
 * master you need.
 */
export function usePintMaster<T extends keyof Pint.MasterSet>(pick?: T) {
  const { result, loading, error } = useRequest(() => getPintMasters(), []);
  return { loading, error, master: !loading && result && pick ? result[pick] : result };
}

interface UseMasterReturn<T> {
  readonly loading: boolean;
  readonly master: T;
  readonly error: string;
}
